import React, { useState, useEffect } from "react";
import { withFormik, Form as Formiker, Field as Fieldmik } from "formik";
import * as yup from "yup";
import {
  Form as FormUi,
  Container, TextArea, Dropdown
} from "semantic-ui-react";
import ReadAxios from "../../../components/axiosComponent/read";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import CreateAxios from "../../../components/axiosComponent/create";
import UpdateAxios from "../../../components/axiosComponent/update";
import { translate } from "react-i18next";
import { isEmpty } from "lodash";
import { AllRegex } from "../../../utils/validation";
import { ERROR_MESSAGES, INVALID_FIELDS, REQUIRED_FIELDS } from "../../../utils/validationConstant";
import {LOCAL_STORAGE} from '../../../utils/constant'
import cogoToast from "cogo-toast";
import MyState from "../../../components/apiInputs/myState";
import {FIELDS} from './zone_constants'

const currentUser = LOCAL_STORAGE.customerNo

const InsertZone = ({ values, setFieldValue, touched, errors, t, ...props }) => {
  return (
    <React.Fragment>
      <Formiker>
        <div className="container-fluid animated slideInDown pad w3-white">
          <div className="ml-3 mr-3 mt-5 mb-5 pl-3">
            <div className="ui form">
              <FormUi.Group inline>
              <FormUi.Field width={3}>
                  <label className="labelName">
                    {FIELDS.zone_code.title||"Zone Code"}
                  </label>
                </FormUi.Field>
              <FormUi.Field width={4} error={touched.zoneCode && errors.zoneCode ? true : false} >
              <div className="container">
              <div className="row">
                <Fieldmik
                type="text"
                className="ui input pe-5"
                name="zoneCode"
                placeholder={FIELDS.zone_code.placeholder||"Enter Zone Code"}
                disabled={props.editData.zoneId ? true : false}
              />
              </div>
              <div className="row">
                      {touched.zoneCode && errors.zoneCode ? (
                        <div className="error-msg">
                          {errors.zoneCode}
                        </div>
                      ) : null}
                    </div>
                    </div>
              </FormUi.Field>
              <FormUi.Field width={1}></FormUi.Field>
                <FormUi.Field width={3}>
                  <label className="labelName">
                    {FIELDS.zone_name.title || "Zone Name"}<span className="red"> *</span>
                  </label>
                </FormUi.Field>
                <FormUi.Field className="display-grid-center-imp" width={4} error={touched.zone && errors.zone ? true : false}>
                  <div className="container">
                    <div className="row">
                      <Fieldmik
                        type="text"
                        className="ui input"
                        name="zone"
                        placeholder={FIELDS.zone_name.placeholder||"Enter Zone Name"}
                        />
                    </div>
                    <div className="row">
                      {touched.zone && errors.zone ? (
                        <div className="error-msg">
                          {errors.zone}
                        </div>
                      ) : null}
                    </div>
                  </div>
                </FormUi.Field>
              </FormUi.Group>

              <FormUi.Group inline>
              <FormUi.Field width={3}>
                  <label className="labelName">
                    {FIELDS.states.title||"States"}
                  </label>
                </FormUi.Field>
              <FormUi.Field width={4} error={touched.stateIds && errors.stateIds ? true : false} >
              <div className="container">
              <div className="row">
              <Fieldmik
                    component={MyState}
                    name="stateIds"
                    multiSelect={true}
                    multiple
                    userId = {values.userId}
                    value={values.stateIds}
                    nameValue="states"
                    placeholder={FIELDS.states.placeholder||"Select States"}
                    initialLoading={true}
                  />
              </div>
              <div className="row">
                      {touched.stateIds && errors.stateIds ? (
                        <div className="error-msg">
                          {errors.stateIds}
                        </div>
                      ) : null}
                    </div>
                    </div>
              </FormUi.Field>
              </FormUi.Group>
            </div>
          </div>
        </div>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="submit"
          >
            {"Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  );
};

const FormikZone = withFormik({
  validationSchema: yup.object({
    zone: yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).max(30, ERROR_MESSAGES.MAX_LENGTH(30)),
    zoneCode: yup.string().optional().nullable()
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
        zone: props.editData.zoneName || "",
        zoneCode: props.editData.zoneCode || "",
        stateIds: props.editData.stateIds || []
    };
  },
  async handleSubmit(values, { props, resetForm }) {
    if (props.editData.zoneId) {
      UpdateAxios({
        url: "zoneMaster",
        payload: { ...values },
        uniqueId: props.editData.zoneId,
      })
        .then((res) => {
          if(res?.data?.status===200){
            cogoToast.success(res?.data?.message, { position: 'top-right' });
            setTimeout(() => {
              props.onFormSubmit();
            }, 500);
          }else{
            cogoToast.error(res?.data?.message, { position: 'top-right' });
          }
          
        })
        .catch((err) => {
            cogoToast.error(err?.data?.message, { position: 'top-right' });
          
        });
    } else {
      CreateAxios({
        completeURL: `${process.env.REACT_APP_MASTER_API}/zoneMaster/`,
        payload: { ...values },
      })
        .then((res) => {
          if(res?.data?.status == 204){
            cogoToast.error(res?.data?.message, { position: 'top-right' });
          }else{
            cogoToast.success(res?.data?.message, { position: 'top-right' });
            setTimeout(() => {
              props.onFormSubmit();
            }, 500);
          }        
        })
        .catch((err) => {
          console.log("error yard", err);
          cogoToast.error(err?.data?.message, { position: 'top-right' });
        });
    }
  },
})(InsertZone);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("zone")(FormikZone)
);
